<template>
    <ResultsNetworkBanner  bannerType="success" header="In network">
        <span>This provider is covered by your 
            <a :data-card-rank="rank"  href="/my/plan-overview/coverage.html">out-of-service-area benefits</a>   – your copay may be different than for in-service-area benefits. 
        </span>
    </ResultsNetworkBanner>    
</template>

<script setup> 
    const props = defineProps({
        rank: Number
    })
</script>